<script setup lang="ts">
import { computed } from "vue";
const page = usePage().value;
const trekConsiderations = computed(() => page?.trekConsiderations ?? []);
</script>

<template>
  <section class="grade-considerations">
    <div
      v-for="(consideration, index) in trekConsiderations"
      :key="index"
      class="item"
    >
      <div class="icon" v-html="consideration.considerationImage"></div>
      <h3>{{ consideration.consideration }}</h3>
      <div v-html="consideration.considerationText" />
    </div>
  </section>
</template>
